module.exports = __webpack_public_path__ + "img/laptop.44a05d51.png";